export enum TaskDbTerminated {
    Terminated = '1',
    NotTerminated = '0'
}
